export default __webpack_public_path__ + "eye-open.a60ff728.svg";